import React, { FunctionComponent, ReactNode, useEffect, useRef } from 'react';
import styles from './AuthCard.module.scss';

export const AUTH_TITLE_ID = 'auth-title';

interface AuthCardProps {
  children: ReactNode;
  /** Szara stopka karty: przejście „Nie masz konta? / Masz już konto?” albo powrót do logowania. */
  footer?: ReactNode;
  /** Rejestracja: szersza karta (imię i nazwisko w jednym wierszu). */
  wide?: boolean;
}

/** Biała karta formularza na środku ekranu /auth (wejście animuje ramka, raz). */
const AuthCard: FunctionComponent<AuthCardProps> = ({ children, footer, wide = false }) => (
  <section className={`${styles.card} ${wide ? styles.wide : ''}`} aria-labelledby={AUTH_TITLE_ID}>
    <div className={styles.body}>{children}</div>
    {footer && <p className={styles.footer}>{footer}</p>}
  </section>
);

interface AuthHeadingProps {
  title: ReactNode;
  lead?: ReactNode;
  /** Wynik akcji (wysłano, zmieniono, błąd linku): tytuł dostaje fokus, czytnik ekranu go ogłasza. */
  focusOnMount?: boolean;
}

/** Tytuł ekranu (jedyny `h1`) i jedno zdanie opisu. */
export const AuthHeading: FunctionComponent<AuthHeadingProps> = ({
  title,
  lead,
  focusOnMount = false,
}) => {
  const ref = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (focusOnMount) ref.current?.focus();
  }, [focusOnMount]);

  return (
    <>
      <h1
        id={AUTH_TITLE_ID}
        ref={ref}
        className={styles.title}
        tabIndex={focusOnMount ? -1 : undefined}
      >
        {title}
      </h1>
      {lead && <p className={styles.lead}>{lead}</p>}
    </>
  );
};

export default AuthCard;
